import { render, staticRenderFns } from "./screen-full.vue?vue&type=template&id=21da8ee9&scoped=true&"
import script from "./screen-full.vue?vue&type=script&lang=js&"
export * from "./screen-full.vue?vue&type=script&lang=js&"
import style0 from "./screen-full.vue?vue&type=style&index=0&id=21da8ee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da8ee9",
  null
  
)

export default component.exports